import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GamesService } from 'src/app/services/games.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Game } from 'src/app/models/game.model';

@Component({
  selector: 'app-game-form',
  templateUrl: './game-form.component.html',
  styleUrls: ['./game-form.component.scss']
})

export class GameFormComponent implements OnInit {

  // case modif game //////////////////////////////////////////////
  game: Game; /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////

  gameForm: FormGroup;
  fileIsUploading = false;
  fileUrl: string;
  fileUploaded = false;

  constructor(private route: ActivatedRoute, // case modif game
              private formBuilder: FormBuilder,
              private gamesService: GamesService,
              private router: Router) { }

  ngOnInit() {
    window.scrollTo(0,0);

    // case modif game //////////////////////////////////////////////
    this.game = new Game('','',{'catAdresse':false, /////////////////
                                'catEstaminet':false, ///////////////
                                'catGeants':false, //////////////////
                                'catEnfant':false, //////////////////
                                'catComptoir':false, ////////////////
                                'catCasseTete':false, ///////////////
                                'catExterieur':false, ///////////////
                                'catCasino':false, //////////////////
                                'catSociete':false, /////////////////
                                'catReflexion':false, ///////////////
                                'catHasard':false, //////////////////
                                'catCooperatif':false, //////////////
                               },'','','',true); ////////////////////
    /////////////////////////////////////////////////////////////////

    this.initForm();                           

    // case modif game //////////////////////////////////////////////
    const game_name = this.route.snapshot.params['game_name']; //////
    if (game_name !== undefined ){ //////////////////////////////////
      this.gamesService.getSingleGame(game_name).then( //////////////
        (game: Game) => { ///////////////////////////////////////////
          this.game = game; /////////////////////////////////////////
          this.initForm();///////////////////////////////////////////
        } ///////////////////////////////////////////////////////////
      ); ////////////////////////////////////////////////////////////
    } ///////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////

  }


  initForm() {
    this.gameForm = this.formBuilder.group({
      title:         [this.game.title,    Validators.required],
      description:   [this.game.description],
      
      catAdresse:    [this.game.categorie['catAdresse']], 
      catEstaminet:  [this.game.categorie['catEstaminet']],
      catGeants:     [this.game.categorie['catGeants']],
      catEnfant:     [this.game.categorie['catEnfant']],
      catComptoir:   [this.game.categorie['catComptoir']],
      catCasseTete:  [this.game.categorie['catCasseTete']],
      catExterieur:  [this.game.categorie['catExterieur']],
      catCasino:     [this.game.categorie['catCasino']],
      catSociete:    [this.game.categorie['catSociete']],
      catReflexion:  [this.game.categorie['catReflexion']],
      catHasard:     [this.game.categorie['catHasard']],
      catCooperatif: [this.game.categorie['catCooperatif']],

      catTar:        [this.game.catTar,   Validators.required],
      ageMin:        [this.game.ageMin,   Validators.required],
      nbrJoeur:      [this.game.nbrJoeur, Validators.required],
      visible:       [this.game.visible]
    })

    this.fileUrl = this.game.photo
  }

  onSaveGame() {
    const title =       this.gameForm.get('title').value;
    const description = this.gameForm.get('description').value;
    const categorie = {
      'catAdresse':     this.gameForm.get('catAdresse').value,
      'catEstaminet':   this.gameForm.get('catEstaminet').value,
      'catGeants':      this.gameForm.get('catGeants').value,
      'catEnfant':      this.gameForm.get('catEnfant').value,
      'catComptoir':    this.gameForm.get('catComptoir').value,
      'catCasseTete':   this.gameForm.get('catCasseTete').value,
      'catExterieur':   this.gameForm.get('catExterieur').value,
      'catCasino':      this.gameForm.get('catCasino').value,
      'catSociete':     this.gameForm.get('catSociete').value,
      'catReflexion':   this.gameForm.get('catReflexion').value,
      'catHasard':      this.gameForm.get('catHasard').value,
      'catCooperatif':  this.gameForm.get('catCooperatif').value,
    };
    const catTar =      this.gameForm.get('catTar').value;
    const ageMin =      this.gameForm.get('ageMin').value;
    const nbrJoeur =    this.gameForm.get('nbrJoeur').value;
    const visible =     this.gameForm.get('visible').value;
    
    
    const newGame = new Game(title,
                             description,
                             categorie,
                             catTar,
                             ageMin,
                             nbrJoeur,
                             visible);
    if(this.fileUrl && this.fileUrl !== ''){
      newGame.photo = this.fileUrl
    }   
    
    
    
    const game_name = this.route.snapshot.params['game_name'];
    if (game_name !== undefined ){
      this.gamesService.editGames(game_name, newGame);
    }else{
      this.gamesService.creatNewGame(newGame);
    }

    this.router.navigate(['/games']);
  }

  onUploadFile(file: File) {
    this.fileUploaded = false;
    this.fileIsUploading = true;
    this.gamesService.uploadFile(file).then(
      (url: string) => {
        this.fileUrl = url;
        this.fileIsUploading = false;
        this.fileUploaded = true;
      }
    )
  }

  detectFiles(event) {
    this.onUploadFile(event.target.files[0]);
  }


  onBack() {
    this.router.navigate(['/games'])
  }

}
